import { isLive } from '@/environment';
import { captureErrorWithContext } from '@/sentry';
import { Button, EmptyState, SvgEmptyStateSystemErrorMedium, Typography } from '@galaxy-react/core';
import { AuthAgent } from '@leapdev/auth-agent';
import { useTitle } from 'ahooks';
import { t } from 'i18next';
import { useEffect, useMemo } from 'react';
import { useRouteError } from 'react-router-dom';
import { Wrapper } from 'src/feature/Searchbox/searchbox.styled';
import eventEmitter from './Utilities/eventEmitter';

type Props = {};

function ErrorBoundary() {
  useTitle('LEAP Reports');

  const error: any = useRouteError();

  //@ts-ignore
  useEffect(() => {
    if (error?.name === 'ChunkLoadError') {
      eventEmitter.emit('toast', {
        title: t('System Upgrade'),
        message: t('Our system has upgraded. Please try again later.'),
        type: 'warning',
      });
      setTimeout(() => {
        AuthAgent.logout();
      }, 5000);
    }
    captureErrorWithContext(error);
  }, [error]);
  const errorMessage = useMemo(() => {
    if (error?.name === 'ChunkLoadError') {
      return t('Our system has upgraded. Please try again later.');
    }
    return t("We've encountered an error!");
  }, [error]);
  return (
    <Wrapper
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <EmptyState
        illustration={<SvgEmptyStateSystemErrorMedium />}
        headline={t("We've encountered an error!")}
        description={
          <>
            <Typography style={{ textAlign: 'center' }}>{errorMessage}</Typography>
            <Button appearance="primary" onClick={() => AuthAgent.logout()} style={{ marginTop: 24 }}>
              {t('Try Again')}
            </Button>
            {!isLive && (
              <Typography style={{ marginTop: 24, textAlign: 'center' }}>
                Error: [{error.name}]-{error.message}
              </Typography>
            )}
          </>
        }
      ></EmptyState>
    </Wrapper>
  );
}

export default ErrorBoundary;
